(function(){
  function init(root){
    if(!root || root.__cgridInit) return; root.__cgridInit = true;
    var addUrl = root.getAttribute('data-cart-add-url') || '/cart/add.js';

    // sort
    root.querySelectorAll('[data-cgrid-sort]').forEach(function(sel){
      sel.addEventListener('change', function(){
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sel.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    });

    // swatch -> swap product in place (no PDP navigation)
    root.querySelectorAll('[data-swatch]').forEach(function(sw){
      sw.addEventListener('click', function(e){
        e.preventDefault();
        var card = sw.closest('.cgrid-card'); if(!card) return;
        var d = sw.dataset;
        var img = card.querySelector('.cgrid-img1');
        if(img && d.img){ img.removeAttribute('srcset'); img.src = d.img; }
        var i2 = card.querySelector('.cgrid-img2'); if(i2){ i2.removeAttribute('srcset'); i2.src = d.hover || d.img; }
        var t = card.querySelector('.cgrid-title');
        if(t && d.url){ t.setAttribute('href', d.url); if(d.title) t.textContent = d.title; }
        var media = card.querySelector('a.cgrid-media'); if(media && d.url) media.setAttribute('href', d.url);
        var price = card.querySelector('.cgrid-price'); if(price && d.price) price.textContent = d.price;
        var idInput = card.querySelector('form[data-cgrid-add] [name=id]'); if(idInput && d.vid) idInput.value = d.vid;
        card.querySelectorAll('[data-swatch]').forEach(function(x){ x.classList.remove('is-active'); });
        sw.classList.add('is-active');
      });
    });

    // quick add (AJAX)
    root.querySelectorAll('form[data-cgrid-add]').forEach(function(form){
      form.addEventListener('submit', function(e){
        e.preventDefault();
        var btn = form.querySelector('button');
        if(btn.disabled) return;
        var original = btn.textContent;
        btn.textContent = '…';
        fetch(addUrl, {
          method:'POST',
          headers:{'Accept':'application/json','Content-Type':'application/json'},
          body: JSON.stringify({ items:[{ id: form.querySelector('[name=id]').value, quantity:1 }] })
        }).then(function(r){ return r.json(); }).then(function(){
          btn.classList.add('is-added'); btn.textContent = '✓ Hinzugefügt';
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          document.dispatchEvent(new CustomEvent('cart:build'));
          setTimeout(function(){ btn.classList.remove('is-added'); btn.textContent = original; }, 1600);
        }).catch(function(){ btn.textContent = original; });
      });
    });
  }
  document.querySelectorAll('.cgrid').forEach(init);
  document.addEventListener('shopify:section:load', function(e){
    var el = e.target.querySelector('.cgrid'); if(el) init(el);
  });
})();
